import React from 'react';
import Icon from '@amzn/awsui-components-console/icon';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import type { UseCase } from '@amzn/aws-gcr-content-connection-management-client';
import './ApplicationCard.scss';

export interface ApplicationCardProps {
  application: UseCase;
  onClick: (id: string) => void;
}

const ApplicationCard: React.FC<ApplicationCardProps> = ({ application, onClick }) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick(application.useCaseId!);
    }
  };

  // Format the createdAt date to a readable format
  const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div className="application-card" onClick={() => onClick(application.useCaseId!)} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
      <SpaceBetween size="s">
        <div className="application-card__header">
          <h3 className="application-card__name">{application.useCaseId}</h3>
          <div className="application-card__icon">
            <Icon name="folder-open" size="medium" />
          </div>
        </div>
        <p className="application-card__joined">Joined {formatDate(application.createdAt!)}</p>
        <p className="application-card__subscriptions">{(application.subscribedCollections || []).length} Subscriptions</p>
      </SpaceBetween>
    </div>
  );
};

export default ApplicationCard;
